var React = require('react');

function VuxenLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M414.43 522l236.75-410h-539.1l236.74 410c14.58 25.28 51.03 25.28 65.61 0z","fill":"#eb008b","key":0}),React.createElement("path",{"d":"M311.82 176.1l-25.43 55.79h-7.71l-25.43-55.79h17.88l11.41 30.19 11.4-30.19zm191.71 0v55.79h-5.41l-29.45-27.81v27h-15.34v-55.8h5.42l29.44 28.3V176.1zm-151.2 83.84v33.39A21.55 21.55 0 01340 313.55a29.74 29.74 0 01-25 0 21.51 21.51 0 01-12.38-20.22v-33.39H318v32.32a10.56 10.56 0 002.29 7c1.54 1.84 3.94 2.72 7.22 2.67s5.69-1 7.22-2.75a10.24 10.24 0 002.3-6.93v-32.31zm105.45 21.57V293H436v8.94h24.69v13.12h-40v-55h40v12.72H436v8.69zm-47.23 62.59l-18.45 26.58 18.45 28.38h-18.86l-10.09-16.4-10.09 16.4h-18.87l19.28-27.15-19.28-27.81h18.87l10.91 16.66 9.27-16.66z","fill":"#fff","key":1})]);
}

VuxenLogo.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 763.26 653.02"};

module.exports = VuxenLogo;

VuxenLogo.default = VuxenLogo;
